import { Card } from "../../primitives/card";
import type {
  IssueRecord,
  AttachmentRecord,
} from "@shared-core/data/api-types";
import { issueTypeLabel } from "@shared-core/domain/issues";
import { ReadField, IssueAttachmentList } from "./IssueFields";

/**
 * The Report tab — what was raised. Visible to every tier (the report
 * tier sees only this tab). Read-only: the report is a record of what
 * was first observed.
 */
export function IssueReportTab({
  issue,
  attachments,
}: {
  issue: IssueRecord;
  attachments: AttachmentRecord[];
}) {
  return (
    <div className="space-y-5">
      <Card className="p-6 space-y-5">
        <ReadField label="Issue type" value={issueTypeLabel(issue.type_id)} />
        <ReadField label="What happened" value={issue.description} />
        <ReadField
          label="Initial action taken"
          value={issue.initial_action}
          empty="No initial action recorded"
        />
        <div className="grid sm:grid-cols-2 gap-5">
          <ReadField
            label="Related job / order"
            value={issue.related_reference}
            empty="None linked"
          />
        </div>
      </Card>

      <Card className="p-6 space-y-3">
        <div className="text-xs uppercase tracking-wide text-muted-foreground">
          Attachments
        </div>
        <IssueAttachmentList attachments={attachments} />
      </Card>
    </div>
  );
}
